import React from "react";
import Sidebar from './sidebar/sidebar.component';
import Bottombar from './bottombar/bottombar.component';
import ControlTutorial from './tutorial.control.component';
import PlayCanvasConnector from './studio.pc.component';
import Topbar from './topbar/topbar.component';
//import Topbar from './topbar.component';

//import CarSelection from './carselection.component';
import Screenshot from './screenshot.component';
import Gallery from './gallery/gallery.component';
// import PDFMenu from './pdfviewer/pdf.component';
import BulletView from './bullets.component';
import InteriorViewer from './interior.viewer.component'; // TEMPORAL (visor interior)
import ReactAudioPlayer from 'react-audio-player';

import IsPortrait from '../helpers/WindowOrientation';
import { BulletsData } from "../../data/bullets.data";


interface Props {
  car: any;
  loaded: boolean;
  isTouchScreen: boolean;
  showStudio: boolean;
  audioMute: boolean;
  isOnARMode: boolean;
  isARSupported: boolean;
  returnToShowroom: () => void;
  setLoaded: (value: boolean) => void;
  setAudioMute: (value: boolean) => void;
  setOnARMode: (value: boolean) => void;
  setARSupported: (value: boolean) => void;
  setProgress: (value: number) => void;
  SelectNewCar: (value: any) => void;
}

const StudioComponent: React.FC<Props> = ({ car, showStudio, loaded, isTouchScreen, audioMute, isOnARMode, isARSupported, setAudioMute, setOnARMode, setARSupported, setProgress, setLoaded, returnToShowroom, SelectNewCar}) => {

  const messageToPCRef = React.useRef<{ SendMessage: (value: any) => void } | null>(null);//Esto es para enviar mensajes a PC sin usar estados, sino acceso directo. HACERLO SIEMPRE ASÍ!
  const bulletsData: any = BulletsData();
  const isPortrait: boolean = IsPortrait();

  const [showScreenshotMenu, setShowScreenshotMenu] = React.useState(false);
  const [showGalleryMenu, setShowGalleryMenu] = React.useState(false);
  const [showBulletMenu, setShowBulletMenu] = React.useState(false);
  // const [showPDFMenu, setShowPDFMenu] = React.useState(false);
  const [bullet, setBullet] = React.useState<any>(null);
  const [closeTutorial, setCloseTutorial] = React.useState(false);
  const [enableAnimations, setEnableAnimations] = React.useState(true);
  const [screenshotURL, setScreenshotURL] = React.useState('');
  //const [messageToPC, sendMessageToPC] = React.useState<any>({});

  const [color, setColor] = React.useState<any>(null);
  const [scenario, setScenario] = React.useState<any>(null);
  const [isInternalView, setInternalView] = React.useState(false);
  const [lightsOn, setLightsOn] = React.useState(false);

  // const [bullet, setBullet] = React.useState<any>(null);
  // const [gallery, setGallery] = React.useState<any>(null);
  const [isCollapsed, setIsCollapsed] = React.useState(true);
  const [seat, setSeat] = React.useState<any>("fl");
  

  React.useEffect(() => {
    setInternalView(false);
    setLightsOn(false);
  }, [car]);

  React.useEffect(() => {
    if(!color)
      return;
    SendMessageToPC('bodycolor', color);
  }, [color]);

  React.useEffect(() => {
    if(!scenario)
      return;
    SendMessageToPC('scenario', scenario);
  }, [scenario]);

  React.useEffect(() => {
    // TEMPORAL (visor interior): el botón "Interior" ya no mueve la cámara 3D al interior;
    // en su lugar se muestra <InteriorViewer/> (ver el render). Para volver al comportamiento
    // anterior: descomentar la línea siguiente y quitar el bloque <InteriorViewer/> del render.
    // SendMessageToPC('view', isInternalView);
    //arreglo bug ventana bullet VS external view
    setShowBulletMenu(false);
    setBullet(null)
    SendMessageToPC('bullet-focus', null);
  }, [isInternalView]);

  React.useEffect(() => {
    SendMessageToPC('lights', lightsOn);
  }, [lightsOn]);

  const SendMessageToPC = (manager: string, message: any) => {
    const data = {sender: 'umbraint-react', recipient: 'umbraint-pc', manager: manager, message: message};
    //console.log("React Sender: ", data);
    if (messageToPCRef.current) {
      messageToPCRef.current.SendMessage(data);
    }
    //sendMessageToPC(data);
  };

  const onMessageReceivedFromPC = (data: any) => {
    if(!data.manager) return;
    //console.log('React: Message received from iframe: ', data);
    ReactLoadManager(data);
    ReactStartManager(data);
    ReactARManager(data);
    ReactBulletManager(data);
    ReactScreenshotManager(data);
    ReactControlsManager(data);
    ReactAnimationManager(data);
  };
  const ReactLoadManager = (data: any) => {
    if(data.manager !== 'load')
      return;
    setProgress(100 * data.message);
  };
  const ReactStartManager = (data: any) => {
    if(data.manager !== 'start')
      return;
    //console.log("STARTED");
    setLoaded(data.message);
    SendMessageToPC('bullet-creation',bulletsData[car.id]);
    SendMessageToPC('bodycolor', color);
    SendMessageToPC('scenario', scenario);
  };
  const ReactARManager = (data: any) => {
    if(data.manager !== 'ar')
      return;
    setARSupported(data.message.supported);
  };
  const ReactBulletManager = (data: any) => {
    if(!data.manager.includes('bullet'))
      return;
    setBulletLocal(data.message);
  };
  const ReactScreenshotManager = (data: any) => {
    if(data.manager !== 'screenshot')
      return;
    const screenshotURL = data.message.url;
    setScreenshotURL(screenshotURL)
  };
  const ReactControlsManager = (data: any) => {
    if(data.manager !== 'controls') //const control = data.message; //rotation | zoom
      return;
    setCloseTutorial(true);
  };
  const ReactAnimationManager = (data: any) => {////nuevo, pero no se necesita.
    if(data.manager !== 'animation')
      return;
    setEnableAnimations(!data.message);
  };

  const TakeScreenshot = () => {
    SendMessageToPC('screenshot','takepicture');
  };
  const DownloadScreenshot = () => {
    SendMessageToPC('screenshot','downloadpicture');
  };
  const FocusBullet = (bullet: any) => {
    SendMessageToPC('bullet-focus', bullet);
  };

  const dependenciesFix = (value: boolean) => {
    if(!value)
      return;
    const a1 = isARSupported;
    const a2 = showGalleryMenu;
    setOnARMode(isOnARMode || a1 || a2);
    
  };
  dependenciesFix(false);

  const setBulletLocal = (value: any) => {
    setBullet(value)
    FocusBullet(value);
  };

  const [bottomMenu, setBottomMenu] = React.useState("Main");
  
  const setLocalBottomMenu = (value: string) => {
    let nextValue = value;
    if(nextValue === 'Gallery'){
      setShowGalleryMenu(true);
      nextValue = 'Options';
    }
    setBottomMenu(nextValue);
  };

  const setLocalShowGalleryMenu = (value: boolean) => {
    setShowGalleryMenu(value);
  };

  const localReturnToShowroom = () => {
    setShowGalleryMenu(false);
    setBottomMenu("Main");
    setIsCollapsed(true);
    returnToShowroom();
  };

  // const setLocalShowPDFMenu = (value: boolean) => {
  //   setShowPDFMenu(value);
  // };

  const setShowPDFMenu = (value: boolean) => {}; //temporal, borrar.

  return (
    <div className={`studio-full-container ${isPortrait ? 'portrait':''} ${showStudio ? '' : 'hide'}`}>

      {/* {car && <PDFMenu car={car} isPortrait={isPortrait} showPDFMenu={showPDFMenu} setShowPDFMenu={setLocalShowPDFMenu}/>} */}
      {/* ORDEN IMPORTA */}
      
      <div className={`studio-3d-container ${isPortrait ? 'portrait':''} ${showStudio ? '' : 'hide'}`}>
        {/* ORDEN IMPORTA */}
        {car && isPortrait && <Screenshot isPortrait={isPortrait} screenshotURL={screenshotURL} showScreenshotMenu={showScreenshotMenu} setShowScreenshotMenu={setShowScreenshotMenu} TakeScreenshot={TakeScreenshot} DownloadScreenshot={DownloadScreenshot} setBottomMenu={setLocalBottomMenu}/>}
        
        {car && <PlayCanvasConnector messageToPCRef={messageToPCRef} car={car} onMessageReceivedFromPC={onMessageReceivedFromPC} isPortrait={isPortrait}/>}

        {/* PARA LA INTERFAZ EN AR, IMPORTANTE QUE QUEDE SEPARADO DE PC, EL UI NO PUEDE CONTENER PC! */}
        <ControlTutorial closeTutorial={closeTutorial} isSceneLoaded={loaded} isTouchScreen={isTouchScreen} isPortrait={isPortrait} isFullTutorial={true}/>

        {/* TEMPORAL (visor interior): quitar este bloque para volver a la vista interior 3D */}
        {car && <InteriorViewer car={car} visible={isInternalView} isPortrait={isPortrait} isCollapsed={isCollapsed}/>}
      </div>
      {car && isPortrait && <Topbar isPortrait={true} audioMute={audioMute} setAudioMute={setAudioMute} returnToShowroom={localReturnToShowroom}/>}

      {car && isPortrait && <Bottombar enableAnimations={enableAnimations} car={car} seat={seat} setSeat={setSeat} bullet={bullet} setBullet={setBulletLocal} color={color} scenario={scenario} showBulletMenu={showBulletMenu} isInternalView={isInternalView} bottomMenu={bottomMenu} setShowBulletMenu={setShowBulletMenu} setBottomMenu={setLocalBottomMenu} setColor={setColor} setScenario={setScenario} showOtherMenus={showScreenshotMenu || showGalleryMenu} setShowScreenshotMenu={setShowScreenshotMenu} setInternalView={setInternalView} setShowGaleryMenu={setLocalShowGalleryMenu}/>}

      {car && <Gallery car={car} isPortrait={isPortrait} setBottomMenu={setLocalBottomMenu} showGalleryMenu={showGalleryMenu} isCollapsed={isCollapsed} setShowGaleryMenu={setLocalShowGalleryMenu}/>}

      {car && !isPortrait && <Sidebar car={car} seat={seat} setSeat={setSeat} color={color} scenario={scenario} isInternalView={isInternalView} isCollapsed={isCollapsed} audioMute={audioMute} showGalleryMenu={showGalleryMenu} setAudioMute={setAudioMute} setColor={setColor} setScenario={setScenario} showOtherMenus={showScreenshotMenu} enableAnimations={enableAnimations} setShowScreenshotMenu={setShowScreenshotMenu} setInternalView={setInternalView} setShowGaleryMenu={setLocalShowGalleryMenu} setShowPDFMenu={setShowPDFMenu} lightsOn={lightsOn} setLightsOn={setLightsOn} setIsCollapsed={setIsCollapsed} returnToShowroom={localReturnToShowroom}/>}
      
      {car && !isPortrait && <Screenshot isPortrait={isPortrait} screenshotURL={screenshotURL} showScreenshotMenu={showScreenshotMenu} setShowScreenshotMenu={setShowScreenshotMenu} TakeScreenshot={TakeScreenshot} DownloadScreenshot={DownloadScreenshot} setBottomMenu={setLocalBottomMenu}/>}
      
      {car &&<BulletView car={car} bullet={bullet} setBullet={setBulletLocal} showBulletMenu={showBulletMenu && !(showScreenshotMenu || showGalleryMenu)} setShowBulletMenu={setShowBulletMenu}/>}

      {/* <Topbar car={car} audioMute={audioMute} setAudioMute={setAudioMute}/> */}
      {showStudio && <ReactAudioPlayer src="./audios/BGM.mp3" autoPlay controls={false} loop muted={audioMute} id={"bgm"} volume={0.1}/>}
      
    </div>
  );
};

export default StudioComponent;
